import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  save: {
    defaultMessage: 'Save',
    id: 'tlzy/L',
    description: 'Save receiving orders for transfer order',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'pTjXs+',
    description: 'Cancel transfer order receive button',
  },
  receiveStock: {
    id: 'TfnF1R',
    defaultMessage: 'Receive Stock',
    description: 'Button label for receiving stock in transfer order',
  },
  bannerContent: {
    id: '1lFmqF',
    defaultMessage: '<b>Need help adding products?</b> Learn how to add products either through a scanner or manual entry.',
    description: 'Instructions for scanning products in the transfer order receive stock drawer',
  },
  learnMore: {
    id: '4v8Qr6',
    defaultMessage: 'Learn more',
    description: 'Link text for learn more section in transfer order',
  },
  scanInstructions: {
    defaultMessage: 'Scan or enter UPC/SKU and adjust any details as needed',
    id: '2yU948',
    description: 'Instructions for transfer order receive form',
  },
  warehouse: {
    defaultMessage: 'Destination Warehouse',
    id: '96s+Re',
    description: 'Warehouse label for transfer order receive form',
  },
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close receive stock drawer',
    id: '4xM966',
    description: 'Aria label for close button in receive stock drawer',
  },
  multiLotWarning: {
    defaultMessage: 'This product has multiple lots. Enter quantities for each lot manually.',
    id: 'RH58UE',
    description: 'Warning message when scanned product has multiple lots to choose from',
  },
  locationRequiredError: {
    defaultMessage: 'Please select a location for all products before saving.',
    id: 'ZRyCy3',
    description: 'Error message when trying to save without selecting locations for all products',
  },
});
